import React, { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Lock, Check } from "lucide-react";

export function EarlyAccess() {
  const [email, setEmail] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim() && !whatsapp.trim()) {
      toast.error("Add an email or WhatsApp number");
      return;
    }
    if (email.trim() && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.trim())) {
      toast.error("Enter a valid email address");
      return;
    }
    if (whatsapp.trim() && whatsapp.replace(/\D/g, "").length < 7) {
      toast.error("Enter a valid WhatsApp number");
      return;
    }
    setLoading(true);
    try {
      await api.post("/early-access", { email, whatsapp, source: "homepage-drop" });
      setDone(true);
      toast.success("You're on the list. First dibs on di next drop.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong");
    }
    setLoading(false);
  };

  return (
    <section data-testid="early-access" className="relative overflow-hidden border-y border-jamaica-gold/30 bg-jamaica-green/10">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center relative z-10">
        <p className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.3em] text-jamaica-gold mb-4">
          <Lock className="w-3.5 h-3.5" /> Members Only
        </p>
        <h2 className="font-display text-4xl sm:text-5xl tracking-tight leading-none">
          FIRST DIBS PON DI NEXT DROP
        </h2>
        <p className="text-zinc-400 text-sm mt-3 max-w-md mx-auto">
          Drops sell out fast. Join the list for early access — you cop before it hit the public.
          No spam, just di link when it live.
        </p>

        {done ? (
          <div data-testid="early-access-done" className="mt-8 inline-flex items-center gap-2 border border-jamaica-green/50 bg-black/40 px-6 py-4 font-mono text-sm uppercase tracking-widest text-jamaica-green">
            <Check className="w-4 h-4" /> Yuh on di list. Big up!
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 flex flex-col sm:flex-row gap-3 max-w-lg mx-auto">
            <Input
              data-testid="early-access-email"
              type="email"
              autoComplete="email"
              aria-label="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              className="bg-black/50 border-border rounded-none h-12 focus-visible:ring-jamaica-gold"
            />
            <Input
              data-testid="early-access-whatsapp"
              type="tel"
              autoComplete="tel"
              aria-label="WhatsApp number"
              value={whatsapp}
              onChange={(e) => setWhatsapp(e.target.value)}
              placeholder="WhatsApp (876...)"
              className="bg-black/50 border-border rounded-none h-12 focus-visible:ring-jamaica-gold"
            />
            <Button
              data-testid="early-access-submit"
              type="submit"
              disabled={loading}
              className="h-12 px-8 bg-jamaica-gold hover:bg-yellow-300 text-black font-bold uppercase tracking-widest rounded-none shrink-0"
            >
              {loading ? "…" : "Get Access"}
            </Button>
          </form>
        )}
      </div>
    </section>
  );
}
